import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/lib/auth-context';

/**
 * Route guard that requires qa or admin role.
 * Must be nested inside a ProtectedRoute (assumes user is authenticated).
 * Redirects to home page if user does not have permission.
 */
export function QARoute() {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[50vh]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600" />
      </div>
    );
  }

  if (user?.role !== 'qa' && user?.role !== 'admin' && user?.role !== 'super_admin') {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
